module.exports = __webpack_public_path__ + "static/img/z404.7d23229f.png";